<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">List of User
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="resetpwd">Reset Password</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="5" lg="4">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Name</span></b-input-group-prepend>
                <b-form-input v-model="tblData.username" placeholder="User Login Name"></b-form-input>
                <b-form-input v-model="tblData.full_name" class="ml-1" placeholder="Employee Full Name" style="width:40% !important"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="7" lg="6">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Company Name</span></b-input-group-prepend>
                <b-form-input v-model="tblData.company" style="width:25% !important"></b-form-input>
                <b-input-group-prepend><span class="pt-2 ml-2 mr-1">status</span></b-input-group-prepend>
                <b-form-select  v-model="tblData.isdeleted" :options="statusOptions" ></b-form-select>
              <b-input-group-append>
                    <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
              </b-input-group-append>
              <b-input-group-append>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>

      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(seqno)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(isdeleted)="data">
          <span v-if="(data.item.isdeleted==1)">Inactive</span>
          <span v-else>Active</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>    
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="8" lg="7">
        <b-card >
          <div slot="header">Manage User  
            <div class="card-header-actions">
              <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</b-button>
            </div>
          </div>
            <b-form-group id="input-group-2" label="Company" label-for="compcode-input" v-if="(usergroup=='admin')">
                <b-input-group >
                    <b-form-input readonly v-model="frmdata.company" :state="!$v.frmdata.compcode.$error"></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuClientShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
          <b-row>
              <b-col md="6">
                    <b-form-group label="Employee ID">
                      <b-input-group >
                          <b-form-input readonly v-model="frmdata.crewinfo" :state="!$v.frmdata.crewkey.$error"></b-form-input>
                          <b-input-group-append>
                          <b-btn text="Button" @click="lkuCrewShow=true" >
                              <i class="fa fa-search"></i>
                          </b-btn>
                          </b-input-group-append>
                      </b-input-group>
                      <div v-if="!$v.frmdata.crewkey.$error" class="invalid-feedback">Employee ID is required</div>
                    </b-form-group>                
              </b-col>
              <b-col md="6">
                    <b-form-group id="input-group-4" label="Email" label-for="email-input">
                      <b-form-input id="email-input" v-model="frmdata.email" :state="$v.frmdata.email.$dirty ? !$v.frmdata.email.$error : null" type="text" required placeholder="Enter Email"></b-form-input>
                      <div v-if="!$v.frmdata.email.required" class="invalid-feedback">Email is required</div>
                    </b-form-group>                
              </b-col>
          </b-row>
          <b-row>
              <b-col md="6">
                    <b-form-group id="input-group-4" label="Full Name" label-for="full_name-input">
                      <b-form-input id="full_name-input" v-model="frmdata.full_name" :state="$v.frmdata.full_name.$dirty ? !$v.frmdata.full_name.$error : null" type="text" required placeholder="Enter Full Name"></b-form-input>
                      <div v-if="!$v.frmdata.full_name.required" class="invalid-feedback">Full Name is required</div>
                    </b-form-group>
              </b-col>
              <b-col md="6">
                    <b-form-group id="input-group-4" label="Mobile Number" label-for="mobile-input">
                      <b-form-input id="mobile-input" v-model="frmdata.mobile" type="text" required placeholder="Enter Mobile Number"></b-form-input>
                    </b-form-group>                
              </b-col>
          </b-row>
          <b-row>
              <b-col md="6">
                    <b-form-group id="input-group-4" label="Username" label-for="username-input">
                      <b-form-input id="username-input" v-model="frmdata.namauser" :state="$v.frmdata.namauser.$dirty ? !$v.frmdata.namauser.$error : null" type="text" required placeholder="Enter Username"></b-form-input>
                      <div v-if="!$v.frmdata.namauser.required" class="invalid-feedback">Username is required</div>
                    </b-form-group>
              </b-col>
              <b-col md="6">
                    <b-form-group id="input-group-2" label="Status" label-for="isdeleted-input" >
                      <b-form-select id="isdeleted-input" v-model="frmdata.isdeleted" :options="statusOptions" ></b-form-select>
                    </b-form-group>
              </b-col>
          </b-row>

              <div style="text-align:center;" class="mt-2">
                <button class="btn btn-primary mr-1" @click="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <button class="btn btn-danger mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</button>
              </div>
              <b-tooltip :show="isEdit" :disabled="!isEdit" target="currentpassword-input" placement="left" class="bg-info">
                Let password field <strong>empty</strong> to keep your <strong>current password</strong>, or enter new password to change password
              </b-tooltip>
        </b-card>        
      </b-col>
    </b-row>
      <!-- <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal> -->

      <b-modal v-model="showDelConfirm" title="Delete Record?" header-bg-variant="danger" :centered="true" >
        <p class="mb-1"><b>{{ this.model.full_name }}</b> will be permanently deleted!</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              variant="secondary"
              size="sm"
              class="float-right m-1"
              @click="showDelConfirm=false"
            >
              Cancel
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              class="float-right m-1"
              @click="deleteData"
            >
              Delete Anyway
            </b-button>
          </div>
        </template>
      </b-modal>
        <b-modal v-model="lkuClientShow" size="lg" :hide-footer="true" title="List of Company" :centered="true">
            <lku-customer @click="onSelectLkuClient" ></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :compcode="compcode" :key="compcode" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        

  </div>
</template>


<script>
import toastr from "mini-toastr";
import users from "../../apis/users";
import lkuCustomer from "../lookup/lkuCompany"
import lkuCrew from "../lookup/lkuCrewlazzy";
import { validationMixin } from "vuelidate";
  import { required, sameAs, minLength } from 'vuelidate/lib/validators'

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
          full_name: {
            required
          },
          email: {
            required
          },
          namauser: {
            required
          },
          crewkey: {
            required
          },
          compcode: {
            required
          }
    },
  }, 
  components:{lkuCustomer,lkuCrew},
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      lkuClientShow:false,
      lkuCrewData:{},
        lkuCrewShow: false,
      showList:true,
      showForm:false,
      isEdit:false,
        statusOptions: [{ value: '0', text: 'Active' }, { value: '1', text: 'Inactive' }],
        frmdata: {
          user_id : '',
          full_name: '',
          email: '',
          namauser: '-',
          katakunci: '-',
          confirmpassword: '',
          crewkey: '',
          isdeleted: '0',
          usergroup: '',
          mobile: '',
          compcode: this.$store.state.user.compcode,
          company: this.$store.state.user.company
        },
        usergroup: this.$store.state.user.group,
        model:{},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'company',
        sortDesc: false
      },
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "username",
            label: "Login Name",
            sortable: true
          },
          {
            key: "full_name",
            label: "Full Name",
            sortable: true
          },
          {
            key: "email",
            label: "Email"
          },
          {
            key: "mobile",
            label: "Mobile Phone",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            sortable: true
          },
          {
            key: "departemen",
            label: "Department",
            sortable: true
          },
          {
            key: "company",
            label: "Company Name",
            sortable: true
          },
          {
            key: "isdeleted",
            label: "status",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    compcode(){
      return this.frmdata.compcode ;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch:{
    compcode(newval){
      this.frmdata.crewkey='';
      this.frmdata.crewinfo='';
    },
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await users.manage(this.tblData);      
      return list;
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            await users.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },     

    search() {
      this.tblData.page=1;
      if (this.$refs.table) this.$refs.table.refresh();
    },
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter() {
        this.tblData.username= '';
        this.tblData.company= '';
        this.tblData.full_name='';
        this.refresh();
    },

    add: function() {
        // for (var key in this.frmdata) {
        //     this.frmdata[key] = '';
        // }
        this.frmdata.isdeleted='0';
          this.frmdata.namauser = '';
          this.frmdata.katakunci = '';
          this.frmdata.full_name = '';
          this.frmdata.email = '';
        this.isEdit=false;

        setTimeout(() => {
          this.frmdata.namauser = '-';
          this.frmdata.katakunci = '-';          
        }, 100);
      // console.log('frmdata : ', this.frmdata);
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        // for (var key in this.frmdata) {
        //     this.frmdata[key] = '';
        // }
        // console.log(this.model);
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
        console.log(this.frmdata)
        this.frmdata.namauser = this.model.username;
        this.frmdata.katakunci = this.model.password;
        this.frmdata.crewinfo = (this.model.crewnik) ? `${this.model.crewnik} | ${this.model.full_name}` : this.frmdata.full_name;
        this.showForm=true;
        this.showList=false;
        this.isEdit=true;

    },
    resetpwd: async function(){
      // let data = {}
      // data.full_name = this.frmdata.full_name;
      // data.email = this.frmdata.email;
      // data.username = this.frmdata.namauser;
      // data.mobile = this.frmdata.mobile;
      // data.crewkey = this.frmdata.crewkey;
      // data.group = this.frmdata.group || 'user';
      // data.isdeleted=this.frmdata.isdeleted || '0';
      // data.compcode = this.frmdata.compcode
      // data.user_id = this.frmdata.user_id || '';
      if (this.model.user_id) {
        try {
          await users.resetpwd(this.model)
            toastr.success(`Reset Password Done, please check user's email`);
        } catch (error) {
          console.log('Reset Password error: ',error)
          if (error.message) {
            toastr.error(error.message)
          } else {
            toastr.error(JSON.stringify(error))
          }
          // this.isLoading = false
        }
      } else {
          toastr.warn('Please select a row that want to be reset password!');
      }

    },
    save: async function (callback) {
        if (this.invalidFormdata) {
            // console.log('validation : ', this.$v.frmdata);
            // console.log('model : ',this.frmdata);
            if (this.frmdata.katakunci && this.frmdata.katakunci.length > 0 && this.frmdata.katakunci.length < 6) {
              toastr.error('Password must be at least 6 characters!', "ERROR MESSAGE");
            } else {
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            }
            

        } else {
          try {
            // start data employee report
            let data = {}
            data.full_name = this.frmdata.full_name;
            data.email = this.frmdata.email;
            data.username = this.frmdata.namauser;
            data.mobile = this.frmdata.mobile;
            data.crewkey = this.frmdata.crewkey;
            data.group = this.frmdata.group || 'user';
            data.isdeleted=this.frmdata.isdeleted || '0';
            data.compcode = this.frmdata.compcode
            if (!this.isEdit) {
              data.password = '123';
              await users.insert(data)
            } else {
              
              if (this.frmdata.katakunci && this.frmdata.katakunci.length >= 6 && this.frmdata.katakunci == this.frmdata.confirmpassword) {
                data.password = this.frmdata.katakunci
              } else if (((this.frmdata.katakunci && this.frmdata.katakunci.length  > 0) || (this.frmdata.confirmpassword && this.frmdata.confirmpassword.length  > 0 )) && this.frmdata.katakunci != this.frmdata.confirmpassword) {
                 toastr.error('Password and Confirm Password must be same!')
                 return
              } else if (this.frmdata.katakunci && this.frmdata.katakunci.length < 6) {
                toastr.error('Password must be atleast 6 characters!')
                 return
              }
              data.user_id = this.frmdata.user_id || '';
              await users.update(data)
            }
            this.closeFrm();
            this.refresh()
          } catch (error) {
            if (error.message) {
              toastr.error(error.message)
            } else {
              toastr.error(JSON.stringify(error))
            }
            // this.isLoading = false
          }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await users.remove(this.model);
      this.showDelConfirm = false;
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    onSelectLkuClient: async function (_selected) {
        this.frmdata.compcode = _selected.compcode;
        this.frmdata.company = _selected.company;
        this.lkuClientShow=false;
    },
    onSelectLkuCrew: async function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.frmdata.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.frmdata.crewkey = lkuData.selected.crewkey;
        this.frmdata.full_name = lkuData.selected.crewname.trim();
        this.frmdata.email = lkuData.selected.crewmail;
        this.frmdata.mobile = lkuData.selected.crewhp;
        this.lkuCrewShow=false;
    },

    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
